/**
 * Extends $templateCache to add logging to failed 'get' calls
 */

firebird.factory('templateCache', [
    '$templateCache',
    'logService',
    'analyticsWrapperService',
    function ($templateCache, logService, analyticsWrapperService) {
        const logger = new LogServiceWrapper(logService, 'templateCache');

        $templateCache.getTemplate = function (template) {
            var retTemplate = $templateCache.get(template);

            if (!retTemplate) {
                logger.error('getTemplate', 'Unable to retrieve template', template);
                analyticsWrapperService.eventTrack('Meeting - templateCache - Unable to retrieve template');
            }

            return retTemplate;
        };

        return $templateCache;
    }
]);
